export const getEntityTypesWithPlaceholders = (
  entityTypes: Array<string>,
): Array<string> => {
  const types: Array<string> = [...entityTypes];

  const hasSCorp: boolean = types.some(
    (type) =>
      type.toLowerCase().startsWith('s-corp') ||
      type.toLowerCase().startsWith('s corp'),
  );

  const hasCCorp: boolean = types.some(
    (type) =>
      type.toLowerCase().startsWith('c-corp') ||
      type.toLowerCase().startsWith('c corp') ||
      type.toLowerCase().startsWith('corp'),
  );

  if (!hasSCorp) {
    types.push('S-Corporation');
  }

  if (!hasCCorp) {
    types.push('C-Corporation');
  }

  return types;
};
